export enum DeliveryForm
{
    Unset = "Unset",
    Personal = "Personal",
    Package = "Package"
}
